import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { PagingSearch } from '../models/common';
import { BuddyUrlSearch, HistorySearch } from '../models/buddy';

@Injectable({
  providedIn: 'root'
})
export class BuddyService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
  ) { }

  getLinkList(search: BuddyUrlSearch){
    let param = JSON.parse(JSON.stringify(search))
    if(param.searchType == '') param.searchType = null
    if(param.urlType == '') param.urlType = null
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/url/list', param)
  }
  addLinkUrl(linkUrl: string, description: string){
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/url', {
      urlValue: linkUrl
      , urlDescription: description
    })
  }
  updateBuddyUrlTitle(urlKey: string, title: string){
    return this.http.put<any>(this.commonService.apiUrl + '/buddy/url/' + urlKey, {
      title: title
    })
  }
  getLinkHistoryList(search: HistorySearch){
    let param = JSON.parse(JSON.stringify(search))
    if(param.keyword == '') param.keyword = null
    if(param.refererGroup == '') param.refererGroup = null
    if(param.buddyType == '') param.buddyType = null
    if(param.urlType == '') param.urlType = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/history/list', param)
  }
  getLinkHistoryDetail(historyNo: number){
    return this.http.get<any>(this.commonService.apiUrl + '/buddy/history/' + historyNo, {})
  }
  getLinkStatsHistoryList(search: HistorySearch){
    let param = JSON.parse(JSON.stringify(search))
    if(param.keyword == '') param.keyword = null
    if(param.refererGroup == '') param.refererGroup = null
    if(param.buddyType == '') param.buddyType = null
    if(param.urlType == '') param.urlType = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/stats/history/list', param)
  }
  getLinkStatsHistoryTotal(search: HistorySearch){
    let param = JSON.parse(JSON.stringify(search))
    if(param.keyword == '') param.keyword = null
    if(param.refererGroup == '') param.refererGroup = null
    if(param.buddyType == '') param.buddyType = null
    if(param.urlType == '') param.urlType = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/stats/history/total', param)
  }
  getLinkStatsHistoryDetail(urlKey: string){
    return this.http.post<any>(this.commonService.apiUrl + '/buddy/stats/history/' + urlKey, {})
  }
}
